module.exports = __webpack_public_path__ + "static/media/store-register.12a398f0.svg";